<template>
  <v-card>
    <v-card-text>
      <v-row class="items-header-table">
        <v-col v-for="header in headers" :key="header">{{ header }}</v-col>
      </v-row>
      <draggable @change="sort()" v-model="sortedItems" group="people" @start="drag=true" @end="drag=false">
        <v-row class="items-row-table" v-for="(item,index) in sortedItems" :key="'new-'+index+'-'+item.id">
          <v-col v-for="(index,col) in item" :key="col+index+'item'">
            <div v-if="col !== 'view'">
              {{ index }}
            </div>
            <div v-else>
              <v-icon color="success" @click="showFile(index)">mdi-eye</v-icon>
            </div>
          </v-col>
        </v-row>
      </draggable>
    </v-card-text>
  </v-card>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: "DraggableTable",
  props: ['items', 'headers'],
  components: {
    draggable
  },
  data() {
    return {
      sortedItems: null,
      sortedIds: [],
    }
  },
  methods: {
    showFile(url) {
      url = url.replace(process.env.VUE_APP_BASE_URL_DEFAULT, '');
      window.axios.post('file-manager/get-data', {
        url: url
      }).then((res) => {
        let baseUrl = process.env.VUE_APP_FRONT_URL
        window.open(baseUrl + 'file/show/' + res.data.data.id, "", "width:800,height=800")
      })
      // window.open(baseUrl + 'file/show/' + url, "", "width:800,height=800")
    },
    sort() {
      this.sortedIds = []
      this.sortedItems.forEach((item) => {
        this.sortedIds.push(item.id)
      })
      this.$emit('sorted', this.sortedIds)
    }
  },
  mounted() {
    this.sortedItems = this.items
  }
}
</script>

<style>
.items-header-table {
  background-color: #fbc658;
  margin: 10px;
  padding: 10px;
  border-radius: 20px;
}

.items-row-table {
  margin: 2px 10px 2px 10px;
  padding: 2px 10px 2px 10px;
  border-style: solid;
  border-radius: 20px;
  border-width: 2px;
  border-color: #d3d3d3;
}

.items-row-table:hover {
  background-color: #6bd098;
  border-style: solid;
  border-color: #a7a5a5;
}

</style>